module.exports = __webpack_public_path__ + "8a5f548004e5d929f439c4a6eb822105.ttf";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Light.ttf
// module id = 358
// module chunks = 0